import React from "react";

const AonContext = React.createContext();

export default AonContext;